module.exports = __webpack_public_path__ + "static/media/spine-image3@2x.0eb0cce5.png";